import {PlayerConfig} from "./config";
import api from "./api/api";
import {init} from "./view/playing";
import Api from "./api/api";

export async function _initPlayer(config: PlayerConfig, api: Api): Promise<{ fnAdd: (r: Recording) => void, pauseAll: () => void }> {
    const viewAPI = init(config.ui, goBack, goForward, playCurrent, pause)
    viewAPI.disable(true);
    let recordings = await api.getAll();
    let currentIndex = 0;
    const audio = new Audio();
    audio.addEventListener("error", () => {
        viewAPI.displayAuthor("no longer available")
        viewAPI.enablePlay(false);
    })

    console.log(`number of recordings ${recordings.length}`)
    viewAPI.enableBack(recordings.length > 1)
    viewAPI.displayAuthor(recordings[0]?.author)
    setIndex(0)

    function goBack() {
        if (recordings.length - 1 > currentIndex) {
            audio.pause();
            setIndex(currentIndex + 1)
        }
    }

    function goForward() {
        if (currentIndex > 0) {
            audio.pause();
            setIndex(currentIndex - 1)
        }
    }

    function setIndex(idx: number) {
        console.log("changing currentIndex to", idx);
        currentIndex = idx;
        viewAPI.displayAuthor(recordings[currentIndex]?.author)
        viewAPI.enableBack(currentIndex < recordings.length - 1)
        viewAPI.enableFwd(recordings.length > 0 && currentIndex > 0)
        viewAPI.enablePauseIfAvailable(false)
        if (recordings[currentIndex]) {
            audio.src = api.baseURL + "/audio/" + recordings[currentIndex].blobId
            viewAPI.enablePlay(true);
        }
    }

    function playCurrent() {
        console.log(currentIndex, recordings[currentIndex])
        audio.volume = 1
        audio.play().then(() => viewAPI.enablePauseIfAvailable(true))
    }

    function pause() {
        console.log(currentIndex, recordings[currentIndex])
        audio.volume = 1
        audio.pause()
        viewAPI.enablePauseIfAvailable(false)
    }

    return {
        fnAdd: (r: Recording) => {
            console.log("fnAdd called");
            recordings = [r, ...recordings]
            setIndex(currentIndex == 0 ? currentIndex : currentIndex + 1)
            console.log("added", recordings);
        },
        pauseAll: () => {
            pause();
        }
    }
}
